import { useAppDispatch } from '@hooks/app/redux';
import { Modal } from '@ui';
import React from 'react';
import { IOfficeHoursWeekRuleWithId } from 'types/e-visits';
import { actions as eVisitsActions } from '@store/ducks/e-visits';
import useOperationStatus from '@lib/hooks/useOperationStatus';
import { showNotification } from '@helpers/notification-helper';
import { useIntl } from 'react-intl';

interface OfficeHoursDeleteProps {
  item?: IOfficeHoursWeekRuleWithId;
  visible: boolean;
  onClose: () => void;
  afterDelete: () => void;
}

const OfficeHoursDelete: React.FunctionComponent<OfficeHoursDeleteProps> = ({
  onClose,
  visible,
  item,
  afterDelete,
}) => {
  const dispatch = useAppDispatch();
  const { formatMessage } = useIntl();

  const { status } = useOperationStatus({
    stateGetter: (state) => state.eVisits.deleteOfficeRuleStatus,
    errorGetter: (state) => state.eVisits.deleteOfficeRuleError,
    resetAction: eVisitsActions.deleteOfficeRuleReset,
    onSuccess: () => {
      showNotification({
        type: 'SUCCESS',
        title: formatMessage({ id: 'eVisit_rules_success' }),
        copy: '',
      });
      afterDelete();
    },
    onError: (error: any) => {
      showNotification({
        type: 'ERROR',
        title: formatMessage({ id: `eVisit_rules_error_${error.errCode}` }),
        copy: '',
      });
    },
  });

  const deleteOfficeHours = React.useCallback(() => {
    if (!item) {
      return;
    }

    dispatch(
      eVisitsActions.deleteOfficeRuleRequest({
        id: item.id,
        dateFrom: new Date().toISOString(),
      }),
    );
  }, [dispatch, item]);

  return (
    <Modal
      destroyOnClose
      visible={visible}
      onClose={onClose}
      title="Odstránenie hodín"
      footer={
        <Modal.Actions
          actions={[
            { key: 'close', label: 'Zrušiť', onClick: onClose, variant: 'ghost' },
            {
              key: 'submit',
              label: 'Odstrániť',
              onClick: deleteOfficeHours,
              variant: 'danger',
              loading: status === 'pending',
            },
          ]}
        />
      }
    >
      <Modal.Title>Naozaj chcete zmazať ordinačné hodiny?</Modal.Title>
    </Modal>
  );
};

export default OfficeHoursDelete;
